import {
    Component,
    forwardRef,
    Input
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import {ContentSearchFilterOptionModel} from "../../models/content-search-filter-option.model";

@Component({
    selector: "pcg-ng-content-category-filter",
    templateUrl: "content-category-filter.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ContentCategoryFilterComponent),
            multi: true
        }
    ]
})
export class ContentCategoryFilterComponent implements ControlValueAccessor {
    @Input() public categories: Array<ContentSearchFilterOptionModel> = [];

    private onChange: (value: Array<ContentSearchFilterOptionModel>) => void = () => {};
    private onTouched: () => void = () => {};

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public writeValue(value: Array<ContentSearchFilterOptionModel>): void {
        if (Array.isArray(value)) {
            this.categories = value;
        }
    }

    protected toggleCategory(category: ContentSearchFilterOptionModel): void {
        category.selected = !category.selected;
        this.onChange(this.categories);
        this.onTouched();
    }
}
